import { rankingCommonConfig } from './common'
import { theme as brandTheme } from '@/config/brands'

export const rankingConfig = {
  ...rankingCommonConfig,
  theme: {
    rankGradient: 'linear-gradient(180deg, #FBE3EA 0%, #FDF6F7 100%)',
    medalNumberTop: '0px',
    tabActiveColor: brandTheme.primaryColor,
    tabInactiveColor: brandTheme.textSecondary,
    medalBg: '#FFFFFF',
    cardBg: '#FFFFFF',
    cardBorder: '#F5E4EA',
  },
  resources: {
    homeBg: '',
    spikeletL: '',
    spikeletR: '',
    goldMedal: '/images/novelyn/ranking/gold.svg',
    silverMedal: '/images/novelyn/ranking/silver.svg',
    bronze: '/images/novelyn/ranking/bronze.svg',
    medal: '/images/novelyn/ranking/default.svg',
  },
}
